import type { NavigateOptions, To } from "react-router-dom";

type NavigateFunction = (to: To, options?: NavigateOptions) => void;

let navigate: NavigateFunction | undefined;

export function setNavigate(fn: NavigateFunction): void {
  navigate = fn;
}

export function navigateTo(to: To, options?: NavigateOptions): void {
  if (!navigate) throw new Error("Navigate function not set");
  navigate(to, options);
}
